<template>
    <v-container class="mb-6 pt-15">
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    :label="$t('Gestión')"
                    :items="itemsYear"
                    v-model="year"
                    outlined
                    @change="getData()"
                ></v-select>
                <v-select
                    :label="$t('Retorno')"
                    :items="itemsType"
                    item-text="label"
                    item-value="val"
                    v-model="type"
                    outlined
                    @change="getData()"
                ></v-select>
            </v-col>
        </v-row>

        <!-- graphics -->
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="justify-center text-h5">
                        <strong v-if="type=='ventas'">{{$t('Retorno ventas')}}</strong>
                        <strong v-else>{{$t('Retorno inversión')}}</strong>
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr class="blue-grey lighten-4">
                                    <th>{{$t('Mes')}}</th>
                                    <th class="text-center">{{$t('Inversion en Bs.')}}</th>
                                    <th class="text-center">{{ type=='ventas' ? $t('Ventas') : $t('Ganancias') }} {{$t('en Bs.')}}</th>
                                    <th class="text-center">{{$t('Retorno sobre')}} {{ type=='ventas' ? $t('ventas') : $t('inversión') }} {{$t('en Bs.')}}</th>
                                    <th class="text-center">{{$t('Retorno sobre')}} {{ type=='ventas' ? $t('ventas') : $t('inversión') }} {{$t('en %')}}</th>
                                    <th class="text-center">{{$t('Estado')}}</th>
                                </tr>
                                <tr class="blue-grey lighten-4">
                                    <th><strong>{{$t('TOTAL')}}</strong></th>
                                    <th class="text-center"><strong>{{ dataTable.map(item => item.investment).reduce((a, b) => a + b, 0) }}</strong></th>
                                    <th class="text-center"><strong>{{ (dataTable.map(item => item.amount).reduce((a, b) => a + b, 0)).toFixed(numberDecimals) }}</strong></th>
                                    <th class="text-center"><strong>{{ (dataTable.map(item => item.return).reduce((a, b) => a + b, 0)).toFixed(numberDecimals) }}</strong></th>
                                    <th class="text-center"><strong :class="(((((-(dataTable.map(item => item.amount).reduce((a, b) => a + b, 0))) / (dataTable.map(item => item.investment).reduce((a, b) => a + b, 0))) - 1) * 100) < 0 ? 'red--text' : 'green--text')">{{ (((-(dataTable.map(item => item.amount).reduce((a, b) => a + b, 0))) / (dataTable.map(item => item.investment).reduce((a, b) => a + b, 0))) - 1) ? ((((-(dataTable.map(item => item.amount).reduce((a, b) => a + b, 0))) / (dataTable.map(item => item.investment).reduce((a, b) => a + b, 0))) - 1) * 100).toFixed(0) : 0 }} %</strong></th>
                                    <th class="text-center">
                                        <v-icon v-if="((((-(dataTable.map(item => item.amount).reduce((a, b) => a + b, 0))) / (dataTable.map(item => item.investment).reduce((a, b) => a + b, 0))) - 1) * 100) < 0" color="error">mdi-close-circle</v-icon>
                                        <v-icon v-else color="success">mdi-check-circle</v-icon>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in dataTable" :key="i">
                                    <td>{{ item.date }}</td>
                                    <td class="text-center">{{ item.investment }}</td>
                                    <td class="text-center">{{ (item.amount).toFixed(numberDecimals) }}</td>
                                    <td class="text-center">{{ (item.return).toFixed(numberDecimals) }}</td>
                                    <td class="text-center"><span :class="(item.icon=='error' ? 'red--text' : 'green--text')">{{ item.return_ }}%</span></td>
                                    <td class="text-center">
                                        <v-icon v-if="item.icon=='error'" color="error">mdi-close-circle</v-icon>
                                        <v-icon v-if="item.icon=='success'" color="success">mdi-check-circle</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: true,
            itemsYear: [],
            year: new Date().getFullYear(),
            itemsType: [{val:'ventas', label:'Ventas'}, {val:'inversion', label:'Inversión'}],
            type: 'ventas',
            dataTable: []
        }
    },
    props: ['money'],
    mounted() {
        // crear lista de años desde el actual hacia atras hasta el 2023
        let year = new Date().getFullYear()
        for (let i = 2023; i <= (+year); i++) {
            this.itemsYear.unshift(i)
        }
        this.itemsYear.unshift(year+1)

        this.getData()
    },
    methods: {
        async getData() {
            this.overlay = true
            this.dataTable = []
            await axios.get(`/admin/return-investment/?year=${this.year}&type=${this.type}`)
            .then((response) => {
                // console.log(response);
                this.dataTable = response.data
                this.overlay = false
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
